import type { ReactNode } from 'react';
import { cn } from '#client/lib/cn';

interface DetailItem {
  label: string;
  value: ReactNode;
  /** Span the full width, for long text such as notes. */
  wide?: boolean;
  /**
   * Render in the mono face with tabular, slashed-zero figures.
   *
   * For identifiers and money — the values people read aloud or compare down a
   * column, where 0/O confusion and misaligned decimals actually cost time.
   */
  mono?: boolean;
}

/**
 * Label/value grid used by every detail screen.
 */
export function DetailList({ items, className }: { items: DetailItem[]; className?: string }) {
  return (
    <dl className={cn('c-detail-list', className)}>
      {items.map((item) => (
        <div
          key={item.label}
          className={cn('c-detail-list__item', item.wide && 'c-detail-list__item--wide')}
        >
          <dt className="c-detail-list__label">{item.label}</dt>
          <dd className={cn('c-detail-list__value', item.mono && 'c-detail-list__value--mono')}>
            {item.value ?? '—'}
          </dd>
        </div>
      ))}
    </dl>
  );
}
